import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import {
  ALL_SURVEYS,
  ALL_SURVEYS_CHANGE_STATUS,
  ALL_SURVEYS_DELETE,
} from './constants';
import {
  AllListSurveySuccess,
  AllListSurveyError,
  AllListSurveyDataActionTypes,
  IAllSurveyState,
  AllListSurveyDelete,
  ISurvey,
  AllListSurveyPublish,
} from './types';

const initialState: IAllSurveyState = {
  status: idle,
  entities: [],
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AllListSurveyDataActionTypes,
  ): IAllSurveyState => {
    switch (action.type) {
      case ALL_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllListSurveySuccess).payload.items;
        break;
      }
      case ALL_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllListSurveyError).error;
        break;
      }
      case ALL_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      case ALL_SURVEYS_DELETE: {
        const newAction = (action as AllListSurveyDelete).payload;
        const newDraft = draft.entities.filter(
          (item: ISurvey) => item.id !== newAction,
        );
        draft.entities = newDraft;
        break;
      }
      case ALL_SURVEYS_CHANGE_STATUS: {
        const newAction = (action as AllListSurveyPublish).payload;
        draft.entities = (draft.entities as ISurvey[]).map((survey) =>
          survey.id === newAction.id
            ? { ...survey, status: newAction.status }
            : survey,
        );
        break;
      }
      default:
        return draft;
    }
  },
);
